import Logo from './cyberconfFooter.svg';

export default Logo;
